const SUCCESS = ['new', 'announced', 'arrived'];
const DANGER = ['declined', 'inerror', 'blocked', 'blacklist', 'cancelled'];
const INFO = ['sent', 'certified', 'completed', 'departed'];

export function statusTone(status?: string | null): 'success' | 'danger' | 'info' | 'neutral' {
  const key = (status ?? '').toLowerCase().replace(/\s+/g, '');
  if (SUCCESS.includes(key)) return 'success';
  if (DANGER.includes(key)) return 'danger';
  if (INFO.includes(key)) return 'info';
  return 'neutral';
}
